export default __webpack_public_path__ + "static/media/controls_touch_2.81d7d360.svg";